/**
 * @desc PDA扫描产品条码上架
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.InMasterPutOnRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/productShelves`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
